export const PLATFORM_ERROR_CODES = [
  'AUTH_ROLE_REQUIRED',
  'CATALOG_CATEGORY_CYCLE',
  'CATALOG_CATEGORY_NOT_EMPTY',
  'CATALOG_OPTION_TAKEN',
  'CATALOG_OPTION_RESERVED',
  'CATALOG_REFERENCE_TAKEN',
  'CATALOG_SLUG_TAKEN',
  'CATALOG_TRANSLATION_MISSING',
  'CATALOG_VARIANT_IN_USE',
  'CONCURRENCY_CONFLICT',
  'CRYPTO_INTEGRITY_FAILED',
  'CRYPTO_UNAVAILABLE',
  'DASHBOARD_VIEW_LIMIT_REACHED',
  'DASHBOARD_VIEW_NAME_TAKEN',
  'DEPENDENCY_UNAVAILABLE',
  'FEATURE_NOT_ENTITLED',
  'IDEMPOTENCY_KEY_REUSED',
  'INVENTORY_INITIAL_STOCK_EXISTS',
  'INVENTORY_INSUFFICIENT_STOCK',
  'INVENTORY_LOCATION_ARCHIVED',
  'INVENTORY_LOCATION_NOT_EMPTY',
  'INVENTORY_DEFAULT_LOCATION_REQUIRED',
  'MEDIA_CHECKSUM_MISMATCH',
  'MEDIA_IMAGE_TOO_LARGE',
  'MEDIA_MALWARE_DETECTED',
  'MEDIA_NOT_READY',
  'MEDIA_PROCESSING_FAILED',
  'MEDIA_TOO_LARGE',
  'MEDIA_TYPE_NOT_ALLOWED',
  'MEDIA_UPLOAD_EXPIRED',
  'MEDIA_UPLOAD_INCOMPLETE',
  'ORDERS_CUSTOMER_PHONE_TAKEN',
  'ORDERS_EXPORT_TOO_LARGE',
  'ORDERS_LINE_INVALID',
  'ORDERS_NOT_EDITABLE',
  'ORDERS_RETURN_NOT_EXPECTED',
  'RATE_LIMITED',
  'RESOURCE_CONFLICT',
  'RESOURCE_NOT_FOUND',
  'SHIPPING_CANCEL_REFUSED',
  'SHIPPING_CANCEL_UNSUPPORTED',
  'SHIPPING_UPDATE_REFUSED',
  'SHIPPING_UPDATE_UNSUPPORTED',
  'SHIPPING_CARRIER_AUTH_FAILED',
  'SHIPPING_CARRIER_NOT_CONFIGURED',
  'ORDERS_CANCEL_IN_PROGRESS',
  'SHIPPING_CARRIER_UNAVAILABLE',
  'SHIPPING_DISPATCH_UNCERTAIN',
  'SHIPPING_CARRIER_VALIDATION_FAILED',
  'SHIPPING_HANDOVER_DUPLICATE',
  'SHIPPING_HANDOVER_REFUSED',
  'SHIPPING_LABEL_NOT_READY',
  'SHIPPING_SENDER_MISSING',
  'SHIPPING_UNREACHABLE',
  'STATE_TRANSITION_INVALID',
  'TEAM_GRANT_NOT_ALLOWED',
  'TEAM_LAST_ADMIN',
  'TEAM_MEMBER_EXISTS',
  'TEAM_SELF_CHANGE',
  'TENANT_SUBSIDIARY_NAME_TAKEN',
  'VALIDATION_FAILED',
] as const;

export type PlatformErrorCode = (typeof PLATFORM_ERROR_CODES)[number];

const known = new Set<string>(PLATFORM_ERROR_CODES);

export const errorMessageKey = (code: string | undefined): string =>
  code !== undefined && known.has(code) ? `errors.${code}` : 'errors.UNKNOWN';
